import React, { useState } from 'react';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import Constants from '../Constants';
import {sanitize_text_input} from '../utils/utils.js';
import { useAuth } from '../AuthContext';
import { get_user_error_message } from '../utils/ErrorMessages';

import '../App.css';

function FeedbackFormView() {
    const { token } = useAuth();

    const [issue_type, set_issue_type] = useState('bug');
    const [name, set_name] = useState('');
    const [description, set_description] = useState('');

    const [loading, set_loading] = useState(false);
    const [error_message, set_error_message] = useState('');
    const [success_message, set_success_message] = useState('');

    const user_id = localStorage.getItem(Constants.USER_ID);
    if(!user_id) {
        console.log('No user logged in.');        
        return;
    }

    const send_form = async(event)=> {
        event.preventDefault();

        set_error_message('');
        set_success_message('');

        if(!sanitize_text_input(name)){
            set_error_message('Invalid name');
            return;
        }

        if(!name.trim()){
            set_error_message('Please enter a summary.');
            return;
        }

        if(!sanitize_text_input(description)){
            set_error_message('Invalid description');
            return;
        }

        if(!description.trim()){
            set_error_message('Please enter a description.');
            return;
        }

        set_loading(true);

        const payload = {
            type: issue_type,
            name: name,
            description: description
        };

        try{
            const url = Constants.SERVER_URL + '/api/report_issue/' + user_id;
            const response = await axios.post(url, payload, {
                headers: token ? { Authorization: 'Bearer ' + token } : {}
            });

            set_loading(false);
            set_success_message('THank you, your feedback/issue has been submitted.');
            set_name('');
            set_description('');
            set_issue_type('bug');

        }catch(error){
            set_loading(false);
			set_error_message(get_user_error_message(error, 'Failed to submit feedback/issue.'));
        }
    };

    return (
        <React.Fragment>
            <main>
                <div className="home-container feedback-form-container">
                    <h3 className='feedback-title'>Submit feedback or report a bug</h3>
                    <p className='aeo-description'>Please tell us what you like or what needs fixing or improving, thank you.</p>

                    <Form as="form" className="feedback-form" onSubmit={send_form}>

                        <Card className="feedback-form-card">

                            <Form.Group className="issue-form-group">
                                <Form.Label>Type</Form.Label>
                                <Form.Select
                                    value={issue_type}
                                    onChange={(e)=> set_issue_type(e.target.value)}>
                                    <option value="bug">Bug</option>
                                    <option value="feedback">Feedback</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="issue-form-group">
                                <Form.Label>Summary</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={name}
                                    onChange={(e)=> set_name(e.target.value)}
                                    placeholder="Short summary"
                                />
                            </Form.Group>

                            <Form.Group className="issue-form-group">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={5}
                                    value={description}
                                    onChange={(e)=> set_description(e.target.value)}
                                    placeholder="Describe the issue or suggestion"
                                />
                            </Form.Group>

                            {error_message ? (
                                <Alert variant="danger" className="issue-alert">
                                    {error_message}
                                </Alert>
                            ) : null}

                            {success_message ? (
                                <Alert variant="success" className="issue-alert">
                                    {success_message}
                                </Alert>
                            ) : null}

                            <Button variant="primary" type="submit" className="issue-submit-button" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
                            </Button>

                        </Card>
                    </Form>
                </div>
            </main>
        </React.Fragment>
    );
}

export default FeedbackFormView;
